import { createAction } from '@reduxjs/toolkit';

const toggleBasketModal = createAction('basketToggle/toggleBasketModal');
export default toggleBasketModal;
